<template>
<div class="" style="padding-bottom: 90px;">
    <div class="bgp" style="text-align: center; text-shadow: 1px 1px 2px #333;">
        <h1 style="color: white; padding-top: 10px; padding-top: 170px;">Product Detail</h1>
        <p style="color: white; padding-top: 10px;">Home > Server Based PMS > Mpe</p>
    </div>
    <div class="container" style="padding-top: 90px;">
        <div style="text-align: center; margin-bottom: 90px;">
            <b-img src="@/assets/PMS/sb2.jpg" fluid alt="Responsive image"></b-img>
        </div>
        <h5>{{ $t('mpeH1') }}</h5>
        
        <h5 style="padding-top: 20px; padding-bottom: 20px;">
            {{ $t('mpeH2') }}        
        </h5>
        <ul style="color: #888888;">
            <li>{{ $t('mpeP1') }}</li>
            <li>{{ $t('mpeP2') }}</li>
            <li>{{ $t('mpeP3') }}</li>
            <li>{{ $t('mpeP4') }}</li>
            <li>{{ $t('mpeP5') }}</li>
        </ul>
        <h5 style="padding-top: 20px; padding-bottom: 20px;">{{ $t('mpeH3') }}</h5>
        <ul style="color: #888888;">
            <li>{{ $t('mpeP6') }}</li>
            <li>{{ $t('mpeP7') }}</li>
            <li>{{ $t('mpeP8') }}</li>
            <li>{{ $t('mpeP9') }}</li>
            <li>{{ $t('mpeP10') }}</li>
        </ul>
        <h5 style="padding-top: 20px; padding-bottom: 20px;">{{ $t('mpeH4') }}</h5>
        <ul style="color: #888888;">
            <li>{{ $t('mpeP11') }}</li>
            <li>{{ $t('mpeP12') }}</li>
            <li>{{ $t('mpeP13') }}</li>
            <li>{{ $t('mpeP14') }}</li>
            <li>{{ $t('mpeP15') }}</li>
        </ul>
        <h5 style="padding-top: 20px; padding-bottom: 20px;">{{ $t('mpeH5') }}</h5>
        <ul style="color: #888888;">
            <li>{{ $t('mpeP16') }}</li>
            <li>{{ $t('mpeP17') }}</li>
            <li>{{ $t('mpeP18') }}</li>
            <li>{{ $t('mpeP19') }}</li>
            <li>{{ $t('mpeP20') }}</li>
        </ul>
        <h5 style="padding-top: 20px; padding-bottom: 20px;">{{ $t('mpeH6') }}</h5>
        <ul style="color: #888888;">
            <li>{{ $t('mpeP21') }}</li>
            <li>{{ $t('mpeP22') }}</li>
            <li>{{ $t('mpeP23') }}</li>
            <li>{{ $t('mpeP24') }}</li>
            <li>{{ $t('mpeP25') }}</li>
        </ul>
        <h5 style="padding-top: 20px; padding-bottom: 20px;">{{ $t('mpeH7') }}</h5>
        <ul style="color: #888888;">
            <li>{{ $t('mpeP26') }}</li>
            <li>{{ $t('mpeP27') }}</li>
            <li>{{ $t('mpeP28') }}</li>
            <li>{{ $t('mpeP29') }}</li>
            <li>{{ $t('mpeP30') }}</li>
        </ul>
         <h5 style="padding-top: 20px; padding-bottom: 20px;">{{ $t('mpeH8') }}</h5>
        <ul style="color: #888888;">
            <li>{{ $t('mpeP31') }}</li>
            <li>{{ $t('mpeP32') }}</li>
            <li>{{ $t('mpeP33') }}</li>
            <li>{{ $t('mpeP34') }}</li>
            <li>{{ $t('mpeP35') }}</li>
        </ul>

        <h4 style="margin-top: 90px; margin-bottom: 40px;">{{ $t('speP36') }}</h4>
        <div class="row">
            <div class="col" style="">
                <b-img v-b-modal.modal-2 src="@/assets/PMS/mpe1.png" fluid alt="Responsive image"></b-img>
            </div>
             <div class="col" style="">
                <b-img  @click="slide = 1" v-b-modal.modal-2 src="@/assets/PMS/mpe2.png" fluid alt="Responsive image"></b-img>
            </div>
             <div class="col" style="">
                <b-img  @click="slide = 2" v-b-modal.modal-2 src="@/assets/PMS/mpe3.png" fluid alt="Responsive image"></b-img>
            </div>
             <div class="col" style="">
                <b-img  @click="slide = 3" v-b-modal.modal-2 src="@/assets/PMS/mpe4.jpg" fluid alt="Responsive image"></b-img>
            </div>
        </div>

        <b-modal id="modal-2" size="xl" style="" hide-footer hide-header>
            <div>
                <b-carousel
                id="carousel-1"
                v-model="slide"
                :interval="3000"
                controls
                background="#ababab"
                img-width="1024"
                img-height="480"
                style="text-shadow: 1px 1px 2px #333;"
                >
                    <b-carousel-slide img-src="@/assets/PMS/mpe1.png"></b-carousel-slide>
                    <b-carousel-slide img-src="@/assets/PMS/mpe2.png"></b-carousel-slide>
                    <b-carousel-slide img-src="@/assets/PMS/mpe3.png"></b-carousel-slide>
                    <b-carousel-slide img-src="@/assets/PMS/mpe4.jpg"></b-carousel-slide>
                </b-carousel>
            </div>
        </b-modal>

    </div>
</div> 
</template>

<script>

export default {
  name: 'Mpe',
  data(){
      return{
       slide: 0,
        }
  },
  async mounted(){
  },

  methods : {
      
  },

  components: {

  },
  props: {

  },
      
 computed: {
  },
}

</script>

<style scoped>
.bgp{
background-image: url("../../assets/att.jpg");
background-size: cover;
height: 400px;
}
.center {
margin-left: 45%;
padding-top: 200px;
color: white;
}
.underline {
  color: black;
  display: inline-block;
  font-size: 0.875rem;
  padding-bottom:2px;
  background-image: linear-gradient(red, red);
  background-position: 0 100%; /*OR bottom left*/
  background-size: 0% 2px;
  background-repeat: no-repeat;
  transition:
  background-size 0.3s,
  background-position 0s 0.3s; /*change after the size immediately*/
}
.underline:hover {
 background-position: 100% 100%; /*OR bottom right*/
  background-size: 100% 2px;
}



</style>
